module.exports = __webpack_public_path__ + "img/FR16006.9d419bff.svg";